import React, { useState, useEffect } from "react"
import ReactPlayer from "react-player"
import { Scrollbars } from "react-custom-scrollbars"
import { AiOutlineCloseCircle } from "react-icons/ai"
import Share from "../share-gallery"
import parse from "html-react-parser"
import LoadingSpinner from "../loading-spinner"
import vGuide from '../../assets/images/gallery-placeholders/video-instructions.png';
import zoomGuide from '../../assets/images/gallery-placeholders/zoom-instructions.png';
import { useGallery } from "./gallery-context"

const BIGA = [
  '01JCBPFA5FQ08KA46WVDDJHZND',
  '01JE5RSA83M4S77P2AF7FS396G',
  '01JF05NVY9BG12ZHB0HNM92WTE',
  '01JEPVYRXJ34B098GGP7ZEAQQG',
  '01JEA94HG4TRE02RCSEYXFSAPR',
  '01JE27NKPE2ST8HD2CXNZGNVC6',
  '01JFE3SWG3KAGQD0651TS54QJD',
  '01JF03DP88ST00KK45AWAFCN6T',
  '01JEV0JN81RCQJH1HNZRG2BN3R',
  '01JFKDF8YEA16MGRRSKQKA7MT6',
  '01JBW7G0PD9CEH2N818SJF7BQX',
  '01JEJ4BE3BAKV7R1GV7GB1YY3N',
]

const BIGW = [
  '01JEDEYB08Q87AC2HJ5561GHPG',
  '01JE7J5FBE1622TVKPWWJXCSKG',
  '01JF0C3H3VS5D98ES960MB2957',
  '01JEBGS3SJD2C2HVNJET6KW29V',
  '01JEAQRNZ1189QC091QM4RJPE0',
  '01JE36KQB0ZS62XN72HJ95XFZ1',
  '01JDXSPK6H1H13CSXSNHGQ9YGJ',
  '01JEVCBY3EDJ0V2YX3FEKP078S',
  '01JE35XARWE30RJK0KA9NFS5KG',
  '01JEMKW1P2X0YTF20M1RG99XEB',
  '01J7A6M9ANM12J1W50T862Y9PN',
  '01JEMHE994ZMAKVN7WP1P17VN2',
]


const SingleWork = props => {
  // context consumer
  const { works, selectedWork, isLoading, fetchSingleWork } = useGallery();
  const workId = props.location.pathname.split('/').pop();
  
  const { title, students, year, seasonYear } = props.location.state || {}; // EDIT - moved "work" to line below
  const work = selectedWork || works[workId] || (props.location.state ? props.location.state.work : null);

  const [fileType, setFileType] = useState(null);
  const [schools, setSchools] = useState([])
  const [portWork, setPortWork] = useState(null);

  const [artPortImage, setArtPortImage] = useState(
    work.isPortfolio && work.isArt && work.portfolioWorks?.length > 0 
    ? work.portfolioWorks[0].assetUrlXLarge : ''
  );

  const [portWorkTitle, setPortWorkTitle] = useState(work.isPortfolio && work.isWriting && work.portfolioWorks?.length > 0 
    ? work.portfolioWorks[0].title
    : ""
  );

const [selectedContent, setSelectedContent] = useState(
  work.isPortfolio && work.isWriting && work.portfolioWorks?.length > 0
    ? work.portfolioWorks[0].excerpt || work.portfolioWorks[0].content
    : ""
);
  const [hasError, setHasError] = useState(false)

  const [loading, setLoading] = useState(true); // Set initial loading to true

  useEffect(() => {
    if (workId && !work) {
      fetchSingleWork(workId);
    }

    // Set loading based on whether we have work data
    if (work && (work.title || work.portfolioWorks?.length > 0)) {
      setLoading(false);
    } else {
      setLoading(isLoading);
    }
  }, [workId, work, isLoading, fetchSingleWork]); // change on these 4 factors destructured from context at top

  async function getFileType(url) {
    const response = await fetch(url, { method: "GET" });
    
    // console.log('getFileType: ', response.headers.get("content-type"));
    return response.headers.get('content-type');

  }

  const getSchools = work => {
    if (!work) return; // skip method if no work

    if (year !== undefined && year > 2023) {
      // console.log('skipping getSchools method for portal data');
      return;
    }
    // console.log("year = ", year);
    let noHome = work.schools?.filter(function (school) {
      return school.name !== "Home School"
    })
    setSchools(noHome)
  }


  useEffect(() => {
    const fetchFileType = async () => {
      if (work.assetUrl) {
        const type = await getFileType(work.assetUrl);
        // console.log("Resolved File Type:", type);
        setFileType(type);
      }
    };

    fetchFileType();
  }, [work?.assetUrl]); // Run on assetUrl change, also check if work is there (work? guard)

  useEffect(() => {
    if (!portWork) return;
  
    if (fileType?.includes("video")) {
      setSelectedContent(portWork.assetUrlXLarge); // Set video source
    } else if (fileType?.includes("image")) {
      setArtPortImage(portWork.assetUrlXLarge);
    } else if (portWork.categoryName === "Portfolio Category(Writing)") {
      setSelectedContent(portWork.excerpt || portWork.content);
    }
  }, [fileType, portWork]);

  useEffect(() => {

    let fetchSchools = async () => {
      try {
        getSchools(work)
      } catch (error) {
        setHasError(true)
        throw new Error(error)
      }
    }
    fetchSchools()
  }, [work]) // added work ehre...empty arr prev

  useEffect(() => {
    if (work && work.isPortfolio && work.portfolioWorks?.length > 0 && !portWork) {
      setPortWork(work.portfolioWorks[0]);
      setSelectedContent(work.portfolioWorks[0].excerpt || work.portfolioWorks[0].content);
    }

    // Always check schools, only call if work
    if (work) {
      getSchools(work);
    }

    // Handle loading state
    if (work && (work.title || work.portfolioWorks?.length > 0 || work.assetUrl || work.content || work.isArt || work.isWriting || work.id?.length > 0)) {
      setLoading(false);
    }
  }, [work, portWork]);

  const handleClick = e => {
    const singleWork = work.portfolioWorks.find(o => o.id === e.target.id)

    setPortWork(singleWork)
  }

    // Handle portfolio work click
    const handleClickPort = async (e) => {
      const index = parseInt(e.target.id, 10);
      if (!work.portfolioWorks || isNaN(index) || index < 0 || index >= work.portfolioWorks.length) {
        console.warn("Invalid portfolioWorks selection");
        return;
      }
  
      const singleWork = work.portfolioWorks[index];
      if (!singleWork) {
        return;
      } else {
        // console.log('singleWork ', singleWork);
        // console.log('singleWOrk.title', singleWork.title);
      }
      setPortWork(singleWork);
      setPortWorkTitle(singleWork.title);
      
      try {
        const actualFileType = await getFileType(singleWork.assetUrlXLarge);
        setSelectedContent("");  
        
        setFileType(actualFileType);
        console.log('file type found = ', fileType);
        
        if (actualFileType.includes('video')) {
            setSelectedContent(null); // Reset first to trigger state update after?
            setTimeout(() => setSelectedContent(singleWork.assetUrlXLarge), 0); 
        } else if (singleWork.categoryName === 'Portfolio Category(Writing)') {
          setSelectedContent(singleWork.excerpt || singleWork.content);
        } else {
          setArtPortImage(singleWork.assetUrlXLarge); // Assume it's an image initially
        }
    } catch (error) {
      console.error("Error fetching file type:", error);
    }
    };
    // good version
    

  if (loading || !work) {
    return (
        <LoadingSpinner />
    )
  }

  if(hasError) {
    return <p>Error loading content.</p>;
  }

  return (
    <div id="gallery-work">
      <div id="gallery-work-contents">
        <div id="gallery-work-label">
          <div className="label-data">
            {students.length > 1 || !work.personPhotoUrl ? (
              <div className="data-artist-no-thumb"></div>
            ) : (
              <div className="data-artist-thumb">
                <img
                  src={work.personPhotoUrl}
                  alt={`Profile Photo: ${work.personName}`}
                />
              </div>
            )}
            <div className="label-data-titles">
              <div className="data-title">{title}</div>

              <div className="data-artist-name">By {work.personName ? work.personName : students ? students.join(", ") : this.props.location.state.work.personName}</div>
            </div>
          </div>
          <div id="close-alert" className="alert" onClick={props.close}>
            <AiOutlineCloseCircle
              size="1.4em"
              fill="white"
              title="Close Dialog"
            />
          </div>
        </div>
        <div className="art-box">
          {work.categoryName === "Video Game Design" ? (
            <div className="art-box-work">
              <div className="art-box-image">
                <img
                  src={work.assetUrl}
                  alt={`${work.title} by ${work.personName}`}
                />
              </div>
            </div>
          ) : work.assetType === "video" ? (
            console.log("Rendering Video section", work) || (
            <div className="art-box-work">
              <div className="art-box-image">
                <ReactPlayer
                  url={work.assetUrl}
                  controls
                  playing
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                        onContextMenu: e => e.preventDefault(),
                      },
                    },
                  }}
                />
              </div>
            </div>
            )
          ) : work.categoryName === "Film & Animation" ? (
            console.log('film & animation', work) ||
           (
            <div className="art-box-work">
              <video width="100%" height="auto" controls poster={work.assetUrl}>
                <source src={work.assetUrl} type="video/mp4" />
                <source src={work.assetUrl} type="video/quicktime" />
                {/* Your browser does not support the video tag. */}
            </video>
            </div>
           )
          ): work.portfolioWorks?.length > 0 && work.isArt ? (
            <div className="art-box-work">
              <div className="art-box-image">
                {portWork.length !== 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", margin: "0 auto" }}>
                    {portWork.title}
                    {fileType?.includes('video') && selectedContent ? (
                    <>
                      {console.log('video')}
                      <video key={selectedContent} controls className="art-box-image">
                      <source src={selectedContent} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    </>
                    ) : (
                      <>
                      {console.log('image')}
                    <img
                      className="art-box-image"
                      src={artPortImage}
                      alt={`${portWork.title} by ${portWork.personName}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = vGuide; // Replace with an actual placeholder if needed
                      }}
                    />
                    </>
                  )}
                  </div>
                ) : (
                  <div>
                    {work.portfolioWorks[0].title}
                    <img
                      className="art-box-image"
                      src={work.portfolioWorks[0].assetUrl}
                      alt={`${work.portfolioWorks[0].title} by ${work.portfolioWorks[0].personName}`}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : work.isArt === true ? (
            <div className="art-box-work">
              <div className="art-box-image">
              {fileType && fileType.startsWith('video/') ? (
                <video
                  className="art-box-image"
                  src={work.assetUrl}
                  controls
                  poster={work.thumbUrl} // Show thumbnail before play
                  onError={(e) => console.error("Video failed to load:", e)}
                  />
                ) : (
                <img
                  className="art-box-image"
                  src={work.assetUrl ? work.assetUrl : work.thumbUrl}
                  alt={`${work.title} by ${work.personName}`}
                />
                )}
              </div>
            </div>
          ) : work.portfolioWorks && work.isWriting && work.isPortfolio ? (
            <div className="writing-box-work">
              <Scrollbars
                autoHide
                autoHideTimeout={1000}
                // Duration for hide animation in ms.
                autoHideDuration={300}
                autoHeight
                autoHeightMin={400}
                autoHeightMax={800}
              // style={{ height: 600 }}
              >

                <div>
                  {/* test */}
                  <p><strong>{portWorkTitle}</strong></p>
                  <p>{parse(selectedContent)}</p>
                </div>
              </Scrollbars>
            </div>
          ) : !work.isPortfolio && work.isWriting ? (
            <div className="writing-box-work">
              <Scrollbars
                autoHide
                autoHideTimeout={1000}
                autoHideDuration={300}
                autoHeight
                autoHeightMin={400}
                autoHeightMax={800}
              >
                {work.content ? parse(work.content) : null}
              </Scrollbars>
            </div>
          ) : null}

          <div className="details">
            <div className="detail-groups scrollbars">
              <div className="detail-group">
                <strong>{students.join(", ")}</strong>
                <ul>
                  {students.length > 1 ? null : (
                    <li>Grade {work.personGrade}</li>
                  )}


                  {/* testing conditional schools */}
                  {work.schools?.map((school, index) => {
                    return (
                      <span key={index}>
                        <li>{school.name}</li>
                        <li>{school.address.slice(0, -5)}</li>
                      </span>
                    )
                  })}
                </ul>
              </div>
              <div className="detail-group">
              {work.teachers && work.teachers.length > 0 && (
                  <strong>{work.teachers.length > 1 ? "Educators" : "Educator"}</strong>
                )}
                {work.teachers && work.teachers.map((teacher, index) => {
                  return (
                    <ul key={index}>
                      <li>{teacher}</li>
                    </ul>
                  )
                })}
              </div>
              <div className="detail-group">
                <strong>Category</strong>
                <div>{work.categoryName}</div>
                {work.awards && work.awards.length > 1 ? (
                  <strong>Awards</strong>
                ) : (
                  <strong>Award</strong>
                )}
                {work.awards && work.awards.map((award, index) => {
                  return (
                    <ul key={index}>
                      {award === "No Cash Award" ? "" : <li>{award}</li>}
                    </ul>
                  )
                })}
                {BIGA.includes(work.id) && (
                  <ul key="best-in-grade-art">
                    <li>Best-in-Grade Art</li>
                  </ul>
                )}
                {BIGW.includes(work.id) && (
                  <ul key="best-in-grade-writing">
                    <li>Best-in-Grade Writing</li>
                  </ul>
                )}
                <span>{work.seasonYear}</span>
              </div>
              {work.portfolioWorks?.length > 0 && work.isWriting ? (
                <div className="detail-group">
                  <strong>Portfolio Works</strong>

                  {work.portfolioWorks.map((portWork, index) => {
                    return (
                      <ul key={index}>
                        <li>
                          <span
                            className="port-thumb-writing"
                            key={portWork.index}
                            id={index}
                            onClick={handleClickPort}
                          >
                            {portWork.title}
                          </span>
                        </li>
                      </ul>
                    )
                  })}
                </div>
              ) : null}

              {work.portfolioWorks?.length > 0 && work.isArt ? (
                <div className="detail-group">
                  <strong>Portfolio Works</strong>
                  <div className="port-thumbs-grid">
                    {work.portfolioWorks.map((portWork, index) => {
                      return (
                        <div className="port-thumb-image">
                          <img
                            key={index}
                            id={index}
                            src={portWork.assetUrl}
                            alt={`${portWork.title} by ${portWork.personName}`}
                            onClick={handleClickPort}
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop if fallback image fails
                              e.target.src = zoomGuide; // Replace with generic image
                            }}
                          />
                        </div>
                      )
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Share location={props.location} title={title} students={students} />
    </div>
  )
}

export default SingleWork